<script>
export default {

    name: 'referrals-modal',

    methods: {
        openModal()
        {
            this.$refs.referralsModal.open()
        },
        done()
        {
            this.$refs.referralsModal.close()
        },
    }

}
</script>

<template lang="html">
    <custom-modal exitIcon="far fa-code-branch" ref="referralsModal">
        <div slot="header" class="">
            <p class="text-lg font-weight-semibold">
                Referrals
            </p>
            <h2 class="font-weight-bold mb-0">
                Minted Free Wedding Kit
            </h2>
            <p class="text-desc-color">
                Minted Co.
            </p>
        </div>
        <div>
            <p class="text-lg font-weight-bold">4 ‘things’ refer to this offer</p>
            <ul class="font-awesomed-list pro paperclip m-0">
                <li>
                    Co-Reg name 1
                </li>
                <li>
                    Other Co-reg Page
                </li>
                <li>
                    Quiz Name
                </li>
                <li>
                    Third thing that refers
                </li>
            </ul>
        </div>
        <div slot="footer" class="">
            <custom-button classes="blue text-white w-120" text="DONE" @buttonClick="done"></custom-button>
        </div>

    </custom-modal>
</template>



// WEBPACK FOOTER //
// src/components/elements/modals/referrals.vue